const getSessionKeys = (role) => {
  const rolePrefix = role ? `${role}_` : '';
  return {
    SESSION_ID_KEY: `${rolePrefix}currentSessionId`,
    SESSION_EMAIL_KEY: `${rolePrefix}sessionEmail`,
    SESSION_TIMESTAMP_KEY: `${rolePrefix}sessionTimestamp`,
    LAST_LOGIN_KEY: `${rolePrefix}lastLoginTimestamp`,
  };
};

export const generateSessionId = () => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

export const setSession = (email, sessionId, role = null) => {
  try {
    const timestamp = Date.now();
    const keys = getSessionKeys(role);
    localStorage.setItem(keys.SESSION_ID_KEY, sessionId);
    localStorage.setItem(keys.SESSION_EMAIL_KEY, email);
    localStorage.setItem(keys.SESSION_TIMESTAMP_KEY, timestamp.toString());
    localStorage.setItem(keys.LAST_LOGIN_KEY, timestamp.toString());
  } catch (error) {
    console.error('Error setting session:', error);
  }
};

export const getSession = (role = null) => {
  try {
    const keys = getSessionKeys(role);
    const sessionId = localStorage.getItem(keys.SESSION_ID_KEY);
    const email = localStorage.getItem(keys.SESSION_EMAIL_KEY);
    const timestamp = localStorage.getItem(keys.SESSION_TIMESTAMP_KEY);
    
    if (sessionId && email) {
      return {
        sessionId,
        email,
        timestamp: timestamp ? parseInt(timestamp, 10) : null,
      };
    }
    return null;
  } catch (error) {
    console.error('Error getting session:', error);
    return null;
  }
};

export const clearSession = (role = null) => {
  try {
    const keys = getSessionKeys(role);
    localStorage.removeItem(keys.SESSION_ID_KEY);
    localStorage.removeItem(keys.SESSION_EMAIL_KEY);
    localStorage.removeItem(keys.SESSION_TIMESTAMP_KEY);
  } catch (error) {
    console.error('Error clearing session:', error);
  }
};

export const isSessionValid = (email, role = null) => {
  const session = getSession(role);
  if (!session) return false;
  
  return session.email === email && session.sessionId !== null;
};

export const checkForNewSession = (currentEmail, currentSessionTimestamp, role = null) => {
  try {
    const keys = getSessionKeys(role);
    const lastLoginTimestamp = localStorage.getItem(keys.LAST_LOGIN_KEY);
    if (!lastLoginTimestamp) return false;
    
    const lastLogin = parseInt(lastLoginTimestamp, 10);
    const currentSession = currentSessionTimestamp || 0;
    
    if (lastLogin > currentSession) {
      const session = getSession(role);
      if (session && session.email === currentEmail) {
        return true;
      }
    }
    
    return false;
  } catch (error) {
    console.error('Error checking for new session:', error);
    return false;
  }
};

